/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-relative-imports */
/* eslint-disable no-duplicate-imports */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

// gimme: conversations-inbox-ui 06/22/2020 c289457d35d0d262a77660b60033b2a3c116e356
'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { SYSTEM_RULES, MANUAL_SPAM, MANUAL_BLOCK, MANUAL, PROVIDER_MARKED_SPAM } from 'conversations-thread-data/thread-details/public/constants';
import { getMostWeightedRules } from 'conversations-thread-data/thread-details/public/utils';
import { getDynamicNamespace } from 'conversations-infrastructure/i18n/getDynamicNamespace';
import { isStarted } from 'conversations-async-data/async-data/operators/statusComparators';
import { getFilteredSource } from 'conversations-thread-data/thread-details/public/operators';
import { useThreadDetails } from 'conversations-thread-view/thread-details-feature/public/hooks/useThreadDetails';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedAlertBannerCta } from '../../constants/CommonEvents';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getIsFiltered } from 'conversations-thread-data/thread-details/public/operators';
import { getUpdatedConversation } from '../../usage-tracking/utils/threadInteraction';
import UndoButton from '../../alerts/components/UndoButton';
import SpamReason from './SpamReason';
import { UNMARK_AS_SPAM_MARKER } from '../../performance-metrics/constants/performanceConstants';
import { useFilterRules } from 'conversations-thread-data/thread-details/public/hooks';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { getAllowDenyListSettingsUrl } from '../../urls/getAllowDenyListSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const spamThreadAlerts = [SYSTEM_RULES, MANUAL_SPAM, MANUAL_BLOCK, MANUAL, PROVIDER_MARKED_SPAM];
export const SpamThreadAlertButton = ({
  loading = false,
  filterType,
  onClickHandler
}) => {
  let buttonProps = {
    loading,
    preventClicksOnLoading: true,
    size: 'extra-small',
    use: 'tertiary'
  };
  // in case of PROVIDER_MARKED_SPAM on click, we want to send the user to
  // the allow and deny settings page
  buttonProps = filterType === PROVIDER_MARKED_SPAM ? Object.assign({}, buttonProps, {
    href: getAllowDenyListSettingsUrl(),
    target: 'blank'
  }) : Object.assign({}, buttonProps, {
    onClick: onClickHandler
  });
  return /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, buttonProps, {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: getDynamicNamespace({
        translationOptions: spamThreadAlerts,
        default: 'MANUAL',
        prefix: 'conversations-thread-view.spam-filtering-and-blocking.FilterThreadAlert.button'
      }, filterType)
    })
  }));
};
const SpamThreadAlert = ({
  threadId
}) => {
  const {
    asyncFilterChangeRequest,
    asyncThreadDetails,
    blockThread,
    markAsSpam,
    unmarkAsSpam,
    unblockThread
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  const filterSource = getFilteredSource(threadDetails);
  const {
    asyncFilterRules
  } = useFilterRules({
    threadId
  });
  const triggeredSpamRules = getData(asyncFilterRules);
  let highestTriggeredSpamRules = List([]);
  let buttonFilterSource = filterSource;
  if (!threadDetails || !getIsFiltered(threadDetails)) {
    return null;
  }
  let alertType = 'warning';
  if (filterSource === SYSTEM_RULES && triggeredSpamRules.size > 0) {
    highestTriggeredSpamRules = getMostWeightedRules(triggeredSpamRules);
    if (highestTriggeredSpamRules.contains(PROVIDER_MARKED_SPAM)) {
      // for PROVIDER_MARKED_SPAM we show a different background and
      // different label for the button compared to other SYSTEM_RULES
      alertType = 'danger';
      buttonFilterSource = PROVIDER_MARKED_SPAM;
    }
  }
  const handleButtonClicked = () => {
    const ctaAction = `unmark thread as ${filterSource.toLowerCase()}`;
    trackEvent(getClickedAlertBannerCta({
      ctaAction
    }));

    /**
     * If the filterSource is MANUAL_BLOCK or MANUAL, unblock the thread
     *
     * Otherwise, the filterSource will be one of [SYSTEM_RULES, MANUAL_SPAM]
     *  and the thread should be unmarked as spam
     */
    if (filterSource === MANUAL_BLOCK || filterSource === MANUAL) {
      unblockThread();
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.alerts.unblocked"
          }), /*#__PURE__*/_jsx(UndoButton, {
            onClick: blockThread
          })]
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.alerts.titles.success"
        }),
        type: 'success'
      });
      trackEvent(getUpdatedConversation({
        updateType: 'unblock'
      }));
    } else {
      performance.mark(`${UNMARK_AS_SPAM_MARKER}-start`);
      unmarkAsSpam();
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.alerts.unmarked-as-spam"
          }), /*#__PURE__*/_jsx(UndoButton, {
            onClick: markAsSpam
          })]
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.alerts.titles.success"
        }),
        type: 'success'
      });
      trackEvent(getUpdatedConversation({
        updateType: 'unmark spam'
      }));
    }
  };
  return /*#__PURE__*/_jsx(UIAlert, {
    type: alertType,
    style: {
      minHeight: 'auto'
    },
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(SpamReason, {
        source: filterSource,
        triggeredSpamRules: highestTriggeredSpamRules,
        isLoading: isLoading(asyncFilterRules)
      }), /*#__PURE__*/_jsx(SpamThreadAlertButton, {
        loading: isStarted(asyncFilterChangeRequest),
        filterType: buttonFilterSource,
        onClickHandler: handleButtonClicked
      })]
    })
  });
};
SpamThreadAlert.displayName = 'FilteredThreadAlert';
SpamThreadAlert.propTypes = {
  threadId: PropTypes.string.isRequired
};
export default SpamThreadAlert;